// extracted by mini-css-extract-plugin
export default {"tag":"tag_zVej","tagRegular":"tagRegular_sFm0","tagWithCount":"tagWithCount_h2kH"};